function bindShareClickListener() {
  $('.js-share-clicked').on('click', function (ev) {

    var form = $('.js-share-form');
    var medium = $(this).data('js-share-medium');
    var is_popup = $(this).hasClass('popup');

    if (is_popup) {
      form.attr("target", "_blank");
    } else {
      form.attr("target", "");
    }

    $('input[name="rshare[medium]"]').val(medium);

    //Calm down click freaks
    setTimeout(function() {

      /**
       * This needs to queued because disabling the submit button before
       * submitting will cancel the submit
       */
      var $button = $(ev.target).prop('disabled', true);
      setTimeout(function() {
        $button.prop('disabled', false);
      }, 2000);
    }, 7);

    return true;
  });
}


/*** EXPORTS FROM exports-loader ***/
module.exports = bindShareClickListener;